var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign"},[_c('div',{ref:"pdf",staticClass:"sign-pdf",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;_vm.show = false}}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdfs",refInFor:true,attrs:{"src":_vm.tmpDocUrl,"page":i}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }